import { useSelector } from '@xstate/store-react';
import { store } from '../store';

export const useQuote = () => useSelector(store, (state) => state.context.quote);
